import { apiHelper } from '@/utils'

const API_URL = process.env.VUE_APP_API_BASE_URL + '/v1'

/**
 * Industry packs — the vocabulary one trade shares.
 *
 * Platform-wide, not per brand: one pack is used by every brand whose
 * Industry field names it, which is why this lives under Admin and not on a
 * brand's page. The server refuses anyone who is not platform staff.
 */
export const tonePackService = { list, get, save, remove }

export async function list() {
  return apiHelper(API_URL).get('/tone-packs')
}

export async function get(name) {
  return apiHelper(API_URL).get(`/tone-packs/${encodeURIComponent(name)}`)
}

export async function save(name, payload) {
  return apiHelper(API_URL).put(`/tone-packs/${encodeURIComponent(name)}`, payload)
}

export async function remove(name) {
  return apiHelper(API_URL).delete(`/tone-packs/${encodeURIComponent(name)}`)
}
